import { IResult } from '../../admin/roundResults/store';

export type TFieldSuffix = 'AuxScore' | 'Position' | 'Score' | 'Tie';

export interface IRoundResultsStore {
  [roundId: number]: {
    [flightId: number]: IResult[];
  };
}

export const roundResultsStore: IRoundResultsStore = {};
